import * as Sentry from '@sentry/react'
import store from '../store';

const detectLevel = (message) => {
  if (/^ERROR:|error|NotCreated|Exception/i.test(message)) return 'error';
  return 'info';
}

export const sendError = (message, data = {}) => {
  const subscription = store.getState().subscription;

  const extra = { ...data };
  if (subscription.email) {
    extra.name = subscription.name;
    extra.email = subscription.email;
  }

  const level = detectLevel(message);

  if (process.env.REACT_APP_ENV === 'production') {
    Sentry.captureMessage(message, { level, extra });
  } else {
    console.log(`errorTracking [${level}]: ${message}`, extra);
  }
}

export default sendError;
